<template>
  <v-col cols="12" md="6" class="py-1">
    <v-badge
      avatar
      overlap
      bordered
      :value="showBetaFeatures ? event.GexDefault : null"
      color="success"
      offset-x="30"
      offset-y="35"
      style="width: 98%"
    >
      <template v-slot:badge>
        <v-avatar color="success" size="36">
          <span class="white--text title">{{ event.GexDefault }}</span>
        </v-avatar>
      </template>
      <v-card
        class="my-1 mb-5"
        elevation="3"
        :disabled="event.Cancelled || event.Postponed ? true : false"
      >
        <v-row
          class="mx-auto my-0 blue white--text action-link"
          @click="$refs.expanded.liteChannel(0)"
        >
          <v-col class="pa-0 ma-0 caption text-center">
            {{ event.ScheduleTitle }}
          </v-col>
        </v-row>
        <div class="action-link" @click="$refs.expanded.liteChannel(0)">
          <event-details :event="event" />
        </div>
        <expanded
          :event="event"
          ref="expanded"
          v-if="event.Cancelled || event.Postponed ? false : true"
        />
        <more :event="event" v-if="showBetaFeatures && (event.HomeMoney > 0 || event.HomeMoney < 0)" />
        
      </v-card>
    </v-badge>
  </v-col>
</template>

<script>
import EventDetails from "./Event/EventDetails";
import Expanded from "./Event/Expanded";
import More from "./Event/More";

export default {
  name: "Event",
  components: {
    EventDetails,
    Expanded,
    More
  },
  props: {
    event: Object,
  },
  computed: {
    primaryChannel() {
      return this.event.MatchingBroadcastEvents[0];
    },
  },
};
</script>

<style scoped>
.action-link {
  cursor: pointer;
}
::v-deep .v-badge__badge {
    border-radius: 50px;
    width: 36px;
    height: 36px;
}
.v-badge--avatar .v-badge__badge .v-avatar {
    height: 36px !important;
    width: 36px !important;
    max-width: unset !important;
}
</style>